/** saves international transfers requests list
@payload { array }
*/
export const SAVE_TMX_LIST = (state, { numberOfProcess, data }) => {
	state.tmxList = numberOfProcess === 0 ? data.internationalTransferProcesses : state.tmxList.concat(data.internationalTransferProcesses)

	state.tmxListHasMore = data.hasMore

    state.tmxNumberOfProcess = data.numberOfProcess
}

/** saves international transfers currencies list
@payload { array }
*/
export const SAVE_TMX_CURRENCY_LIST = (state, data) => {
	state.tmxCurrencyList = data.data.internationalTransferCurrencies
}

/** saves international transfers estimated amount
@payload { object }
*/
export const SAVE_TMX_ESTIMATED_AMOUNT = (state, data) => {
	state.tmxEstimatedAmount = data
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.tmxList = []
	state.tmxListHasMore = false
	state.tmxCurrencyList = []
	state.tmxEstimatedAmount = {}
}
